import api from "@/lib/api";

// Returns the active site query suffix (?venue_id=...) from the site switcher, or "".
export function siteQuery(prefixChar = "?") {
  const s = localStorage.getItem("cc_site");
  return s ? `${prefixChar}venue_id=${s}` : "";
}

// Wrap a list path with the active-site filter, respecting an existing query string.
export function withSite(path) {
  const s = localStorage.getItem("cc_site");
  if (!s) return path;
  return path + (path.includes("?") ? "&" : "?") + `venue_id=${s}`;
}

export default api;
